import instance from "..";

export const viewAllPolicy = () =>
  instance.get("/api/backend/v1/policy/viewall/public?status=active");

export const viewPolicyById = (id) =>
  instance.get(`/api/backend/v1/policy/view/${id}/public`);
